import React from "react";

const FaqRow = ({ faq, open, onToggle }) => {
  const panelId = `fq-answer-${faq.id}`;
  const buttonId = `fq-question-${faq.id}`;

  return (
    <li className={`fq-row${open ? " is-open" : ""}`}>
      <button
        type="button"
        id={buttonId}
        className="fq-question"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => onToggle(faq.id)}
      >
        <span className="fq-question-text">{faq.question}</span>

        <span className="fq-toggle" aria-hidden="true">
          <span className="fq-toggle-bar" />
          <span className="fq-toggle-bar fq-toggle-bar-v" />
        </span>
      </button>

      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        className="fq-answer"
        aria-hidden={!open}
      >
        <div className="fq-answer-inner">
          <p>{faq.answer}</p>
        </div>
      </div>
    </li>
  );
};

export default FaqRow;
